/*let _sendAuthHeader = true;
let _env = "prod";
let PROJECT_ID = "upsra-st";
let API_KEY = "AIzaSyCRzwgToOtwwOlgp33fG7Fo-R3cNJiuS1w";
let AUTH_DOMAIN = "upsra-st.firebaseapp.com";
let DATABASE_URL = "https://upsra-st.firebaseio.com";
let STORAGE_BUCKET = "upsra-st.appspot.com";
let MESSAGING_SENDER_ID = "155269957861";
let SERVER = "https://sindicappweb.com/upsra-1.0.1-DEV/api";
let SERVERDOMAIN = "https://sindicappweb.com/upsra-1.0.1-DEV/api";*/

let _sendAuthHeader = true;
let _env = "prod";
let PROJECT_ID = "upsra-4afb8";
let API_KEY = "AIzaSyAFbfDXH5UDSYNSPOtZAS_6OGHgRUpAfNM";
let AUTH_DOMAIN = "upsra-4afb8.firebaseapp.com";
let DATABASE_URL = "https://upsra-4afb8.firebaseio.com";
let STORAGE_BUCKET = "upsra-4afb8.appspot.com";
let MESSAGING_SENDER_ID = "945555009125";
let SERVER = "https://upsra.vortex-it.com/upsra/api";
let SERVERDOMAIN = "https://upsra.vortex-it.com/upsra/api";

class Settings {
	static get env() {
		return _env;
	}

	static set env(value) {
		_env = value;
	}
	static get API_KEY() {
		switch (_env) {
			case "local":
				API_KEY = "AIzaSyCRzwgToOtwwOlgp33fG7Fo-R3cNJiuS1w";
				break;
			case "staging":
				API_KEY = "AIzaSyCRzwgToOtwwOlgp33fG7Fo-R3cNJiuS1w";
				break;
			case "prod":
				API_KEY = "AIzaSyAFbfDXH5UDSYNSPOtZAS_6OGHgRUpAfNM";
				break;
			default:
				API_KEY = "AIzaSyCRzwgToOtwwOlgp33fG7Fo-R3cNJiuS1w";
		}
		return API_KEY;
	}

	static get PROJECT_ID() {
		switch (_env) {
			case "local":
				PROJECT_ID = "upsra-st";
				break;
			case "staging":
				PROJECT_ID = "upsra-st";
				break;
			case "prod":
				PROJECT_ID = "upsra-4afb8";
				break;
			default:
				PROJECT_ID = "upsra-st";
		}
		return PROJECT_ID;
	}

	static get AUTH_DOMAIN() {
		switch (_env) {
			case "local":
				AUTH_DOMAIN = "upsra-st.firebaseapp.com";
				break;
			case "staging":
				AUTH_DOMAIN = "upsra-st.firebaseapp.com";
				break;
			case "prod":
				AUTH_DOMAIN = "upsra-4afb8.firebaseapp.com";
				break;
			default:
				AUTH_DOMAIN = "tucheck-3798a.firebaseapp.com";
		}
		return AUTH_DOMAIN;
	}
	static get DATABASE_URL() {
		switch (_env) {
			case "local":
				DATABASE_URL = "https://upsra-st.firebaseio.com";
				break;
			case "staging":
				DATABASE_URL = "https://upsra-st.firebaseio.com";
				break;
			case "prod":
				DATABASE_URL = "https://upsra-4afb8.firebaseio.com";
				break;
			default:
				DATABASE_URL = "https://upsra-st.firebaseio.com";
		}
		return DATABASE_URL;
	}
	static get STORAGE_BUCKET() {
		switch (_env) {
			case "local":
				STORAGE_BUCKET = "upsra-st.appspot.com";
				break;
			case "staging":
				STORAGE_BUCKET = "upsra-st.appspot.com";
				break;
			case "prod":
				STORAGE_BUCKET = "upsra-4afb8.appspot.com";
				break;
			default:
				STORAGE_BUCKET = "upsra-st.appspot.com";
		}
		return STORAGE_BUCKET;
	}
	static get MESSAGING_SENDER_ID() {
		switch (_env) {
			case "local":
				MESSAGING_SENDER_ID = "155269957861";
				break;
			case "stagin":
				MESSAGING_SENDER_ID = "155269957861";
				break;
			case "prod":
				MESSAGING_SENDER_ID = "945555009125";
				break;
			default:
				MESSAGING_SENDER_ID = "155269957861";
		}
		return MESSAGING_SENDER_ID;
	}
	static get sendAuthHeader() {
		return _sendAuthHeader;
	}

	static set sendAuthHeader(value) {
		_sendAuthHeader = value;
	}

	static get server() {
		switch (_env) {
			case "local":
				SERVER = "http://localhost:9090/api";
				break;
			case "dev":
				SERVER = "https://api.vault-dev.com/upsra-1.0.1-DEV/api";
				break;
			case "st":
				SERVER = "https://sindicappweb.com/upsra-1.0.1-SNAPSHOT/api";
				break;
			case "prod":
				SERVER = "https://upsra.vortex-it.com/upsra/api";
				break;
			default:
				SERVER = "https://api.vault-dev.com/upsra-1.0.1-DEV/api";
				break;
		}
		return SERVER;
	}

	static get serverDomain() {
		switch (_env) {
			case "local":
				SERVERDOMAIN = "http://localhost:9090";
				break;
			case "dev":
				SERVERDOMAIN = "https://api.vault-dev.com/upsra-1.0.1-DEV";
				break;
			case "st":
				SERVERDOMAIN = "https://sindicappweb.com/upsra-1.0.1-SNAPSHOT";
				break;
			case "prod":
				SERVERDOMAIN = "https://upsra.vortex-it.com/upsra/api";
				break;
			default:
				SERVERDOMAIN = "https://api.vault-dev.com/upsra-1.0.1-DEV";
				break;
		}
		return SERVERDOMAIN;
	}
}

module.exports = Settings;



// WEBPACK FOOTER //
// ./src/provider/base/Settings.js